<template>
  <div>
    <Card :title="$t('common.Action')">
      <CardSection>
        <BaseNodeProperties
          :node="node"
          :readonly="readonly"
        />
        <FormLayout>
          <Select
            :label="$t('common.Type')"
            :placeholder="$t('common.Choose a type')"
            :options="actionTypes"
            :disabled="readonly"
            searchable
            v-model="node.actionType"
          />
          <Select
            v-if="node.actionType === 'SEND_TO_ENDPOINT'"
            :label="$t('common.Endpoint')"
            :options="endpoints"
            :disabled="readonly"
            searchable
            :placeholder="$t('common.Choose an endpoint')"
            @change="changeEndpoint"
            v-model="node.actionId"
          />
          <Select
            v-if="node.actionType === 'SEND_NOTIFICATION'"
            :label="$t('common.Notification')"
            :placeholder="$t('common.Choose a notification')"
            :options="notifications"
            :disabled="readonly"
            searchable
            v-model="node.actionId"
          />
        </FormLayout>
      </CardSection>
      <CardSection
        v-if="node.actionType === 'SEND_TO_ENDPOINT' && canUseRecommendations"
        :title="$t('common.Product recommendations')"
      >
        <FormLayout>
          <Checkbox
            :label="$t('common.Enable product recommendations')"
            :help-text="$t('help.includeDataRecommendation')"
            :value="node.fillRecommendation"
            :disabled="readonly"
            @change="setRecommendation"
          />
          <Checkbox
            v-if="node.fillRecommendation"
            :label="$t('common.Merge into session products')"
            :help-text="$t('help.fillRecommendation')"
            :disabled="readonly"
            v-model="node.fillIntoProducts"
          />
          <RangeSlider
            v-if="node.fillRecommendation"
            :label="$t('common.Number of products')"
            :help-text="$t('help.maxProducts')"
            :disabled="readonly"
            :min="1"
            :max="10"
            v-model="node.numProductsToFill"
          />
        </FormLayout>
      </CardSection>
    </Card>
    <PropertyEditor
      v-if="node.actionType !== 'SEND_TO_RECOMMENDATION'"
      :title="$t('common.Action data')"
      :show-options="node.actionType === 'UPDATE_USER_DATA'"
      :items="node.dataItems"
      :readonly="readonly"
    />
    <!-- {{node}} -->
  </div>
</template>

<script>
import PropertyEditor from '../PropertyEditor'
import mixin from './propertiesMixin'

export default {
  mixins: [mixin],
  components: {
    PropertyEditor
  },
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  computed: {
    actionTypes() {
      const options = [
        {
          value: 'SEND_TO_ENDPOINT',
          label: this.$t('common.Send to Endpoint'),
          disabled: !this.endpoints.length
        },
        {
          value: 'SEND_NOTIFICATION',
          label: this.$t('common.Send Notification'),
          disabled: !this.notifications.length
        }
      ]
      if (this.canUseRecommendations) {
        options.push({
          value: 'SEND_TO_RECOMMENDATION',
          label: this.$t('common.Send to Recommendation Service')
        })
      }
      options.push({
        value: 'UPDATE_USER_DATA',
        label: this.$t('common.Update User Data')
      })
      return options
    },
    endpoints() {
      return this.account.esps
        .map(d => ({
          value: d.id,
          label: this.$t('common.nameESP', { name: `${d.name}` })
        }))
    },
    notifications() {
      return this.account.notifications
        .map(d => ({
          value: d.id,
          label: d.name
        }))
    },
    canUseRecommendations() {
      return this.$store.state.productRecommendations
    },
    numProductOptions() {
      return Array(10).fill(0).map((v, i) => ({
        label: i + 1,
        value: i + 1
      }))
    }
  },
  methods: {
    setRecommendation(value) {
      this.node.fillRecommendation = value
      if (value) {
        this.node.fillIntoProducts = false
        this.node.numProductsToFill = 5
      }
    }
  }
}
</script>
